import { create } from "zustand";
import {
  DOMAIN_LINKING_INTEGRATION_TABS,
  DOMAIN_PRE_LINKING_STEPS,
} from "../constants/DomainLinking.constants";

export const DomainLinkingStore = create((set) => ({
  isLinked: false,
  setIsLinked: (isLinkedValue) => set({ isLinked: isLinkedValue }),

  activeTab: DOMAIN_LINKING_INTEGRATION_TABS.GUIDE,
  setActiveTab: (tab) => set({ activeTab: tab }),

  activeSetupStep: DOMAIN_PRE_LINKING_STEPS.ADD_DOMAIN,
  setActiveSetupStep: (step) => set({ activeSetupStep: step }),

  domainDetails: null,
  setDomainDetails: (details) => set({ domainDetails: details }),

  recordModalState: {
    open: false,
    record: null,
  },
  setRecordModalState: (val, record) =>
    set({
      recordModalState: { open: val, record: record },
    }),

  isFetched: false,
  setIsFetched: (isFetchedValue) => set({ isFetched: isFetchedValue }),

  resetStore: () =>
    set({
      isLinked: false,
      activeSetupStep: DOMAIN_PRE_LINKING_STEPS.ADD_DOMAIN,
      domainDetails: null,
      isFetched: false,
    }),
}));

export const useDomainLinkingStore = DomainLinkingStore;
